// export const server = `https://portal-api-cvs.coder.com.my/api/` //staging
export const server = `https://cvskl-manage.coder.com.my/api/` //new staging
// export const server = `https://phpstack-1307318-4997334.cloudwaysapps.com/api/` //live
// export const server = `http://portal-api.localhost/api/`
// export const server = `http://192.168.0.6:8000/api/`

export const code = (code) => {
    if (code === "INVALID_USER")
        return "You have no permission to perform this action."
    else if (code === "not_found")
        return "Not Found."
    else if (code === "file_oversize")
        return "Please make sure file size are less than 5MB."
    else if (code === "invalid_status")
        return "Invalid status."
    else if (code === "email_exist")
        return "Email is already taken."
    else if (code === "phone_exist")
        return "Phone is already taken."
    else if (code === "ic_exist")
        return "IC is already taken."
    else if (code === "unknown_error")
        return "Unexpected Error Occurs."

    else {
        return "An error occur. Please try again later"
    }
}